/**
 * UpgradeToast — upgrade prompt that appears when a user tries to access a
 * locked feature. Includes the feature-specific message and a "View Plans"
 * button that navigates to the pricing page.
 *
 * Rendered once at the root level in App.tsx. Subscribes to `usePricingStore`
 * to react to upgrade prompt events emitted by `useFeatureAccess`.
 */

import React from 'react';
import { usePricingStore } from './pricingStore';

export function UpgradeToast() {
    const upgradePromptVisible = usePricingStore((s) => s.upgradePromptVisible);
    const upgradeMessage = usePricingStore((s) => s.upgradeMessage);
    const hideUpgradePrompt = usePricingStore((s) => s.hideUpgradePrompt);
    // const onNavigateToPricing = usePricingStore((s) => s.onNavigateToPricing);

    if (!upgradePromptVisible) return null;

    const handleViewPlans = () => {
        hideUpgradePrompt();
        // Open the pricing page in a new tab. The ?page=pricing param is detected
        // by App.tsx on load and auto-navigates to the pricing view.
        window.open(`${window.location.origin}${window.location.pathname}?page=pricing`, '_blank', 'noopener,noreferrer');
    };

    return (
        <div className='upgrade-toast' role='alert' aria-live='polite'>
            <span className='upgrade-toast__message'>{upgradeMessage}</span>

            <div className='upgrade-toast__actions'>
                <button className='upgrade-toast__cta' onClick={handleViewPlans}>
                    View Plans →
                </button>

                <button
                    className='upgrade-toast__close'
                    onClick={hideUpgradePrompt}
                    aria-label='Dismiss upgrade prompt'
                >
                    ✕
                </button>
            </div>
        </div>
    );
}
